import { AnyIfEmpty } from 'react-redux';
import {
    GET_ADMIN_SEARCH_LIST_FAILURE,
    GET_ADMIN_SEARCH_LIST_REQUEST,
    GET_ADMIN_SEARCH_LIST_SUCCESS,
    ADD_ADMIN_LOCATION_FAILURE,
    ADD_ADMIN_LOCATION_REQUEST,
    ADD_ADMIN_LOCATION_SUCCESS,
    GET_INVITED_ADMIN_FAILURE,
    GET_INVITED_ADMIN_REQUEST,
    GET_INVITED_ADMIN_SUCCESS,
    REMOVE_INVITED_ADMIN_FAILURE,
    REMOVE_INVITED_ADMIN_REQUEST,
    REMOVE_INVITED_ADMIN_SUCCESS,
    CLEAR_MESSAGES,
} from '../constants/invitedLocations.constant';


const initialState = {
    loading: false,
    data: [],
    errorMsg: '',
    addAdminLocation: {
        loading: false,
        data: [],
        errorMsg: '',
    },
    invitedAdmin: {
        loading: false,
        data: [],
        errorMsg: '',
    },
    removeInvitedAdmin: {
        loading: false,
        data: [],
        errorMsg: '',
    },
};

export const invitedLocationsReducer = (state = initialState, action: AnyIfEmpty<object>) => {
    switch (action.type) {
        case GET_ADMIN_SEARCH_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                errorMsg: '',
            };
        case CLEAR_MESSAGES:
            return {
                ...state,
                addAdminLocation: {
                    ...state.addAdminLocation,
                    data: [],
                    errorMsg: '',
                },
                invitedAdmin: {
                    ...state.invitedAdmin,
                    data: [],
                    errorMsg: '',
                },
                removeInvitedAdmin: {
                    ...state.removeInvitedAdmin,
                    data: [],
                    errorMsg: '',
                },
            };
        case GET_ADMIN_SEARCH_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
            };
        case GET_ADMIN_SEARCH_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                errorMsg: action.payload,
            };
        case ADD_ADMIN_LOCATION_REQUEST:
            return {
                ...state,
                addAdminLocation: {
                    ...state.addAdminLocation,
                    loading: true,
                    data: [],
                    errorMsg: '',
                },
                removeInvitedAdmin: {
                    ...state.removeInvitedAdmin,
                    data: [],
                },
            };
        case ADD_ADMIN_LOCATION_SUCCESS:
            return {
                ...state,
                addAdminLocation: {
                    ...state.addAdminLocation,
                    loading: false,
                    data: action.payload,
                },
            };
        case ADD_ADMIN_LOCATION_FAILURE:
            return {
                ...state,
                addAdminLocation: {
                    ...state.addAdminLocation,
                    loading: false,
                    errorMsg: action.payload,
                },
            };
        case GET_INVITED_ADMIN_REQUEST:
            return {
                ...state,
                invitedAdmin: {
                    ...state.invitedAdmin,
                    loading: true,
                    data: [],
                    errorMsg: '',
                },
            };
        case GET_INVITED_ADMIN_SUCCESS:
            return {
                ...state,
                invitedAdmin: {
                    ...state.invitedAdmin,
                    loading: false,
                    data: action.payload,
                },
            };
        case GET_INVITED_ADMIN_FAILURE:
            return {
                ...state,
                invitedAdmin: {
                    ...state.invitedAdmin,
                    loading: false,
                    errorMsg: action.payload,
                },
            };
        case REMOVE_INVITED_ADMIN_REQUEST:
            return {
                ...state,
                removeInvitedAdmin: {
                    ...state.removeInvitedAdmin,
                    loading: true,
                    data: [],
                    errorMsg: '',
                },
                addAdminLocation: {
                    ...state.addAdminLocation,
                    data: [],
                },
            };
        case REMOVE_INVITED_ADMIN_SUCCESS:
            return {
                ...state,
                removeInvitedAdmin: {
                    ...state.removeInvitedAdmin,
                    loading: false,
                    data: action.payload,
                },
            };
        case REMOVE_INVITED_ADMIN_FAILURE:
            return {
                ...state,
                removeInvitedAdmin: {
                    ...state.removeInvitedAdmin,
                    loading: false,
                    errorMsg: action.payload,
                },
            };

        default:
            return state;
    }
};